module.exports = __webpack_public_path__ + "./images/d24145bc3ac7182f916775a5103a969e.jpg";